import {AppSettingsRepo, SettingsKeys} from "../../domain/settings/IAppSettingsRepo";

const persistAuthUser = async (user: any) => {
    await AppSettingsRepo.set(SettingsKeys.authUser, user);
}

export default persistAuthUser;